// import API from "../../../app/api";

import API from "../../../app/api";

// export const getProductDetails = async () => {
//   try {
//     const response = await API.get("/products/aquarius-214");
//     if (response.data.success) {
//       return response.data.data;
//     }
//     return [];
//   } catch (error) {
//     console.log(error);
//     return [];
//   }
// };


export const getProductDetails = async (slug, source='header', includeComingSoon = 0) => {
  try {
    const response = await API.get(`/products/${slug}?source=${source}&includeComingSoon=${includeComingSoon}`);

    return response.data?.data || [];
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch product details"
    );
  }
};

export const getProductDetails2 = async (slug) => {
  try {
    const response = await API.get(`/products/${slug}/v2`);

    return response.data?.data || [];
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Failed to fetch product details"
    );
  }
};

